import { render, staticRenderFns } from "./OrganizationBlockingTag.vue?vue&type=template&id=eef0cf5e"
import script from "./OrganizationBlockingTag.vue?vue&type=script&lang=js"
export * from "./OrganizationBlockingTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports